import _ from "lodash";
import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { Table, Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { adminAPI } from "redux/api";

import { push } from "react-router-redux";

import { apiUrls, formLink } from "./init";

import { FloatUsers } from "components/special/users";
import { LoadingIcon } from "components/special";

const { api } = adminAPI.actions;

const SpecialsSettings = (props) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(false);
  const [settings, setSettings] = useState({});
  const [modalOpen, setModalOpen] = useState(false);

  const toggleModal = () => setModalOpen(!modalOpen);

  useEffect(() => {
    if (modalOpen) {
      props.getSpecialSettings(
        {},
        {
          onSuccess(body) {
            setLoading(false);
            setSettings(body);
          },
          onRequest() {
            setSettings({});
            setLoading(true);
            setError(false);
          },
          onFailure() {
            setLoading(false);
            setError(true);
          },
        },
      );
    }
  }, [modalOpen]);

  const saveHandler = () => {
    const confirmed = window.confirm("Сохранить");

    if (confirmed) {
      const onSuccess = (body) => {
        setSaving(false);
      };
      const onRequest = () => {
        setSaving(true);
      };
      const onFailure = () => {
        setSaving(false);
      };
      props.saveSpecialSettings({ body: settings }, { onSuccess, onRequest, onFailure });
    }
  };

  return (
    <>
      <button className="btn btn-sm -btn-secondary" onClick={toggleModal}>
        <i className={`fa fa-cog ${loading ? "fa-spin" : ""}`} />
      </button>
      {modalOpen ? (
        <Modal size="lg" toggle={toggleModal} isOpen={true}>
          <ModalHeader toggle={toggleModal}></ModalHeader>
          <ModalBody>
            {loading ? (
              <LoadingIcon />
            ) : (
              <>
                {settings._id ? (
                  <Table responsive style={{ position: "relative" }}>
                    <tbody>
                      <tr>
                        <td>Пользователь в Telegram</td>
                        <td>
                          <FloatUsers
                            _id={settings.telegramUserId}
                            showTitle={true}
                            showCount={false}
                            multi={false}
                            title={(user) => user.profile?.name}
                            successHandler={([telegramUserId = null]) => {
                              setSettings({ ...settings, telegramUserId });
                            }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Пользователь в Max</td>
                        <td>
                          <FloatUsers
                            _id={settings.maxUserId}
                            showTitle={true}
                            showCount={false}
                            multi={false}
                            title={(user) => user.profile?.name}
                            successHandler={([maxUserId = null]) => {
                              setSettings({ ...settings, maxUserId });
                            }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td></td>
                        <td>
                          <Button className="btn btn-success" onClick={saveHandler}>
                            {saving ? <LoadingIcon className="mr-2" /> : null}
                            Сохранить
                          </Button>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                ) : (
                  <>{"Ошибка загрузки"}</>
                )}
              </>
            )}
          </ModalBody>
        </Modal>
      ) : null}
    </>
  );
};

export default connect(null, {
  getSpecialSettings: api.get(apiUrls.message_settings),
  saveSpecialSettings: api.post(apiUrls.message_settings),
})(SpecialsSettings);
